<div class="content_wrapper">
    <app-text contentId="1YVUsz6ho8LsTKwDdMj2IS"></app-text>
</div>